import { useLocation, useNavigate } from 'react-router-dom'

interface UseTabNavigationOptions {
  replaceOnPush?: boolean
  preserveQueryParams?: boolean
}

export const useTabNavigation = <T extends Record<string, string>>(subTabs: T, options?: UseTabNavigationOptions) => {
  const { replaceOnPush, preserveQueryParams = true } = options ?? {}
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const tabParam = searchParams.get('t')

  const tabValues = Object.values(subTabs) as T[keyof T][]

  const selectedTab = tabValues.find(item => item === tabParam) || tabValues[0]
  const selectedTabIndex = tabValues.findIndex(item => item === selectedTab)

  const handleTabChange = (tabIndex: number) => {
    const newParams = new URLSearchParams()

    newParams.set('t', tabValues[tabIndex])

    if (preserveQueryParams) {
      searchParams.forEach((value, key) => {
        if (key !== 't') {
          newParams.set(key, value)
        }
      })
    }

    navigate(`?${newParams.toString()}`, { replace: replaceOnPush })
  }

  return { selectedTab, selectedTabIndex, handleTabChange }
}
